"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectConnection = void 0;
var tslib_1 = require("tslib");
var net_1 = require("net");
var tls = require("tls");
var AbstractConnection_1 = require("./AbstractConnection");
var DirectConnection = /** @class */ (function (_super) {
    tslib_1.__extends(DirectConnection, _super);
    function DirectConnection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._socket = null;
        return _this;
    }
    Object.defineProperty(DirectConnection.prototype, "port", {
        get: function () {
            return this._port;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DirectConnection.prototype, "hasSocket", {
        get: function () {
            return !!this._socket;
        },
        enumerable: false,
        configurable: true
    });
    DirectConnection.prototype.sendRaw = function (line) {
        var _a;
        (_a = this._socket) === null || _a === void 0 ? void 0 : _a.write(line);
    };
    DirectConnection.prototype.connect = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this._logger) === null || _a === void 0 ? void 0 : _a.trace('DirectConnection connect');
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                _this._connecting = true;
                                if (_this._secure) {
                                    _this._socket = tls.connect(_this._port, _this._host);
                                }
                                else {
                                    _this._socket = new net_1.Socket();
                                    _this._socket.connect(_this._port, _this._host);
                                }
                                _this._socket.on('connect', function () {
                                    var _a;
                                    (_a = _this._logger) === null || _a === void 0 ? void 0 : _a.trace('DirectConnection onConnect');
                                    _this._connecting = false;
                                    _this._connected = true;
                                    _this.emit(_this.onConnect);
                                    resolve();
                                });
                                _this._socket.on('error', function (err) {
                                    var _a;
                                    (_a = _this._logger) === null || _a === void 0 ? void 0 : _a.trace("DirectConnection onError message:" + err.message);
                                    _this._connected = false;
                                    _this._connecting = false;
                                    _this.emit(_this.onDisconnect, false, err);
                                    reject(err);
                                });
                                _this._socket.on('data', function (data) {
                                    _this.receiveRaw(data.toString());
                                });
                                _this._socket.on('close', function (hadError) {
                                    var _a;
                                    (_a = _this._logger) === null || _a === void 0 ? void 0 : _a.trace("DirectConnection onClose hadError:" + hadError.toString());
                                    if (!hadError) {
                                        _this._connected = false;
                                        _this._connecting = false;
                                        _this.emit(_this.onDisconnect, true);
                                    }
                                    if (_this._socket) {
                                        _this._socket.removeAllListeners('connect');
                                        _this._socket.removeAllListeners('error');
                                        _this._socket.removeAllListeners('data');
                                        _this._socket.removeAllListeners('close');
                                        _this._socket = null;
                                    }
                                });
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DirectConnection.prototype.disconnect = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this._logger) === null || _a === void 0 ? void 0 : _a.trace('DirectConnection disconnect');
                        return [4 /*yield*/, new Promise(function (resolve) {
                                if (_this._socket) {
                                    var listener_1 = _this.onDisconnect(function () {
                                        listener_1.unbind();
                                        resolve();
                                    });
                                    _this._socket.end();
                                }
                                else {
                                    resolve();
                                }
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DirectConnection;
}(AbstractConnection_1.AbstractConnection));
exports.DirectConnection = DirectConnection;
//# sourceMappingURL=DirectConnection.js.map